import { inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs';

import { ProductPublicModels } from '@features/products/product';
import { getProductsByIds } from '@features/products/productsArray/infrastructure/state/productsArray.selectors';
import { EventFrom } from '@shared/analytics/COMMON/models/analytics-common.models';
import { GA4EventType } from '@shared/analytics/GA4/models/general.model';
import { GA4AnalyticsPublicActions } from '@shared/analytics/GA4/public.api';
import { LoadRelatedCarouselProductsSuccess } from '@shared/product/related-products/infrastructure/state/related-products.actions';
import { getRelatedProductsPlace } from '@shared/product/related-products/infrastructure/state/related-products.selectors';

export const ViewItemListGA4Event$ = createEffect((
    actions$ = inject(Actions),
    store = inject(Store),
) => {
    return actions$.pipe(
        ofType(LoadRelatedCarouselProductsSuccess),
        filter(({ productsMap }) => !!Object.values(productsMap).length),
        map(({ productsMap, placeName, carousel }) => {
            const place = store.selectSignal(getRelatedProductsPlace(placeName))();
            const productsIds = Object.values(productsMap).map((item) => item.id);
            const relatedProducts = store.selectSignal(getProductsByIds(productsIds))();

            const mappedProducts: ProductPublicModels.PublicProduct[] = relatedProducts.map((prod) => {
                const relatedProduct = Object.values(productsMap).find((item) => item.id === prod.id);
                return {
                    ...prod,
                    relatedType: relatedProduct.relatedType,
                };
            });

            return GA4AnalyticsPublicActions.Ga4Event({
                name: GA4EventType.view_item_list,
                eventFrom: mappedProducts[0].relatedType as EventFrom,
                data: {
                    items: [...mappedProducts],
                    place: placeName,
                    relatedsSectionId: carousel.id,
                    baseProduct: place.baseProducts?.[0] as unknown as ProductPublicModels.PublicProduct,
                },
            });
        }),
    );
}, { functional: true });

export const GA4RelatedProductsAnalyticsEffects = {
    ViewItemListGA4Event$,
};
